import styled from "@emotion/styled";
import Input from "@mui/material/Input";

export const StyledInput = styled(Input)`
  background: rgba(42, 221, 186, 0.16);
  border: 1px solid #2ADDBA;
  padding: 0 24px;
  height: 48px;'
  font-family: "General Sans";
  font-weight: 500;
`;